(function () {
  // One-open-at-a-time for FAQ built with .tab-toggle checkboxes
  var FAQ_GROUP = '.rb-faq-container';
  var TOGGLE = '.tab-toggle';

  // When a question is opened (checkbox becomes checked), uncheck others in the same group
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || input.tagName !== 'INPUT' || !input.classList.contains('tab-toggle')) return;

    var group = input.closest(FAQ_GROUP);
    if (!group || group.classList.contains('faq-allow-multi')) return;

    if (input.checked) {
      var checked = group.querySelectorAll(TOGGLE + ':checked');
      for (var i = 0; i < checked.length; i++) {
        if (checked[i] !== input) checked[i].checked = false;
      }
    }
  }, true); // capture = true works well with dynamically added sections

  // Keep only the first checked on initial load (in case multiple are preset)
  function normalizeFaq() {
    var groups = document.querySelectorAll(FAQ_GROUP + ':not(.faq-allow-multi)');
    for (var g = 0; g < groups.length; g++) {
      var checked = groups[g].querySelectorAll(TOGGLE + ':checked');
      for (var i = 1; i < checked.length; i++) checked[i].checked = false;
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', normalizeFaq);
  else normalizeFaq();
})();
